export default __webpack_public_path__ + "static/media/p2023-28.e04524cf.jpeg";